import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITransporter } from 'src/core/interfaces/transporter';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransporterService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  getTransporters(hideEmptyTransporters?: boolean) {
    let params = new HttpParams();
  
    if (hideEmptyTransporters) {
      params = params.set('hideEmptyTransporters', '1'); // Ensure value is a string
    }
  
    return this.http.get<any>(`${this._baseUrl}/transporter`, {
      params: hideEmptyTransporters ? params : undefined, // Only set params if true
    });
  }
  

  getAllPaginated(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null,
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/transporter/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }
  getTransporter(id: number){
    return this.http.get<any>(`${this._baseUrl}/transporter/${id}`);
  }

  getTransporterDrivers(id: number){
    return this.http.get<any>(`${this._baseUrl}/transporter/TransporterDrivers/${id}`);
  }
  deleteTransporter(id: number){
    return this.http.delete<any>(`${this._baseUrl}/transporter/${id}`)
  }

  addTransporter(transporter: ITransporter){
    return this.http.post<any>(`${this._baseUrl}/transporter/Add`, transporter);
  }

  updateTransporter(id: number,transporter: ITransporter){
    return this.http.patch<any>(`${this._baseUrl}/transporter/${id}`, transporter);
  }

  

  deleteTransporters(ids: number[]){
    return this.http.delete<any>(`${this._baseUrl}/transporter/delete/range`, {body: ids});
  }

  getPaginatedTransporters(pageIndex = 0, pageSize = 10, pagination = false, criteria = null, isActive = -1){
    return this.http.get<any>(`${this._baseUrl}/transporter/paginated/${isActive}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? "&criteria="+criteria : ""}`)
  }

  getSapTransportersSync(){
    return this.http.get<any>(`${this._baseUrl}/Transporter/sync`);
  }

  getLastSapSync(){
    return this.http.get<any>(`${this._baseUrl}/Transporter/LastSyncDate`);
  }
}
